"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PILL = exports.ICON = exports.DEFAULT = void 0;
const PILL = exports.PILL = 'PILL';
const ICON = exports.ICON = 'ICON';
const DEFAULT = exports.DEFAULT = 'DEFAULT';